export enum Status {
  /** Holds its warranties and expires after a TTL. */
  DRAFT = 'DRAFT',

  /** Has a payment; no longer expires. Stays locked while the charge is settled or retried. */
  SUBMITTED = 'SUBMITTED',

  /** Charged and its warranties funded. Terminal, and releases the seller's lock. */
  PAID = 'PAID',

  CANCELLED = 'CANCELLED',

  /** Passed its TTL and released its warranties. Marked lazily, on the seller's next batch. */
  EXPIRED = 'EXPIRED',
}

export const StatusLabel: Record<Status, string> = {
  [Status.DRAFT]: 'Draft',
  [Status.SUBMITTED]: 'Submitted',
  [Status.PAID]: 'Paid',
  [Status.CANCELLED]: 'Cancelled',
  [Status.EXPIRED]: 'Expired',
};
